import styled from 'styled-components'
import { WhiteBlock } from 'components/Layout'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const JobAddHomeContainer = styled(WhiteBlock)``

export const BlockTitle = styled.div`
  ${Font14};
  color: ${theme.colors.moreGrey};
`

export const BlockMsg = styled.div`
  margin-top: ${theme.spacing.lg};
  display: flex;
  justify-content: center;
`

export const BlockMsgInner = styled.div`
  ${Font14};
  line-height: 20px;
  max-width: 600px;
  color: ${theme.colors.moreGrey};
`

export const CtaBtnContainer = styled.div`
  margin-top: ${theme.spacing.lg};
  display: flex;
  justify-content: center;
`
